import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';

export default function ChangePasswordPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { user, fetchProfile } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('A senha deve ter pelo menos 6 caracteres.'); return; }
    if (password !== confirm) { setError('As senhas não coincidem.'); return; }
    setLoading(true);

    // Atualizar senha no Supabase Auth
    const { error: authError } = await supabase.auth.updateUser({ password });
    if (authError) { setError('Erro ao atualizar senha: ' + authError.message); setLoading(false); return; }

    // Marcar must_change_password como false
    await supabase.from('profiles').update({ must_change_password: false }).eq('id', user.id);

    // Recarregar perfil
    await fetchProfile(user.id);

    setLoading(false);
    navigate('/');
  }

  return (
    <div className="login-bg">
      <div className="login-glow" />
      <div className="login-card fade-in">
        <div className="login-logo">
          <span className="login-logo-icon">🔐</span>
          <div>
            <h1 className="login-title">Fincasa</h1>
            <p className="login-sub">Crie sua nova senha</p>
          </div>
        </div>

        <div className="alert" style={{ background:'var(--warn-dim)', border:'1px solid var(--warn)', color:'var(--warn)', fontSize:'0.82rem', marginBottom: 8 }}>
          ⚠️ Por segurança, defina uma senha pessoal antes de continuar.
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Nova Senha</label>
            <input
              type="password"
              placeholder="Mínimo 6 caracteres"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Confirmar Senha</label>
            <input
              type="password"
              placeholder="Repita a senha"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
            />
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <button className="btn btn-primary w-full login-btn" disabled={loading}>
            {loading ? <><span className="spinner" /> Salvando...</> : 'Salvar e Continuar'}
          </button>
        </form>
      </div>
    </div>
  );
}
